import {Component} from '@angular/core';
import {WaTextDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-about-aside',
	templateUrl:'./AboutAsidePage.html',
	styles: [],
	styleUrls:['./AboutAsidePage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		WaTextDirective,
],
	standalone:true
})
export class AboutAsidePage
{
}
